var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSustainBuildingLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 324,
    viewBox: "0 0 372 324",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.305 164.039C225.087 83.6693 152.366 31.2937 61.1522 6.90729C-30.0611 -17.4792 -86.6214 22.708 -108.521 127.459C-130.42 232.215 -125.635 327.264 -94.1677 412.612C-62.7001 497.96 -1.03906 548.469 90.8154 564.145C182.67 579.82 250.603 537.147 294.615 436.128C338.627 335.105 333.522 244.408 279.305 164.039Z",
    fill: "#99CBC7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_190_56137)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_190_56137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.2761 539.54H90.9655V210.922L35.2761 206.225V539.54Z",
    fill: "#32988F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.955 539.454L230.334 492.166V135.718L160.955 112.191V539.454Z",
    fill: "#32988F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2728 526.622L-6.91994 526.583V237.815L35.2728 206.21V526.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.954 539.445H83.5036V170.712L160.954 112.183V539.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.803 561.049C130.586 565.331 108.619 568.076 78.2174 565.711C-4.27218 550.588 -58.2098 493.157 -81.9496 452.288C-115.091 395.233 -117.949 326.71 -118.82 302.807C-118.958 298.863 -118.601 401.398 -47.3228 470.848C-18.479 498.953 18.8514 513.362 56.9537 512.926C71.9888 512.748 88.567 511.023 102.237 505.771C177.334 476.893 200.341 415.312 207.839 326.26C208.453 318.947 208.809 282.081 208.809 282.081V75.9123C208.809 75.9123 297.813 9.39599 297.813 9.59419C297.813 18.7709 297.813 191.384 297.813 293.161C297.813 353.949 294.885 392.539 270.829 443.992C270.829 443.992 238.978 523.966 141.803 561.03V561.049Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4756 556.087C42.4756 556.087 230.139 617.267 292.713 373.241C299.201 347.936 297.169 284.871 297.169 284.871V9.59387C297.169 9.49472 366.568 73.0447 366.568 73.2628C366.568 83.3951 366.568 218.645 366.568 330.972C366.568 333.729 366.528 336.584 366.429 339.479C361.941 470.848 256.261 551.316 166.897 567.086C100.218 578.853 42.4756 556.087 42.4756 556.087Z",
    fill: "#32988F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_190_56137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490.813,
    height: 560.929,
    fill: "white",
    transform: "translate(-118.813 9.5625)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_190_56137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490.813,
    height: 560.929,
    fill: "white",
    transform: "translate(-125.188 9.57422)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainBuildingLeft);
export default __webpack_public_path__ + "static/media/sustain_building_left.40e19474e9567db31738131a115f9876.svg";
export { ForwardRef as ReactComponent };